var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#2EBAC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9004 12.1354L9.891 4.52362C9.72 4.12987 9.46912 3.9375 9.13669 3.9375H8.87063C8.53763 3.9375 8.28619 4.13044 8.11631 4.52362L6.80738 7.84012H5.81681C5.51981 7.84125 5.27906 8.09212 5.27681 8.40263V8.4105C5.27906 8.72156 5.51981 8.97244 5.81681 8.97356H6.34894L5.09962 12.1354C5.0759 12.205 5.06337 12.2779 5.0625 12.3514C5.0625 12.5286 5.11425 12.6675 5.21044 12.7755C5.30606 12.8835 5.43937 12.9375 5.60981 12.9375C5.72221 12.9357 5.83105 12.8978 5.92031 12.8295C6.01594 12.7603 6.08287 12.6596 6.13406 12.5443L7.50994 8.97356H8.46394C8.76038 8.97244 9.00113 8.721 9.00394 8.4105V8.39531C9.00113 8.08425 8.76038 7.83281 8.46394 7.83225H7.95375L9.00338 5.09456L11.8648 12.5437C11.9166 12.6591 11.9829 12.7597 12.0791 12.8289C12.1697 12.8976 12.2783 12.9358 12.3902 12.9369C12.5601 12.9369 12.6934 12.8829 12.7896 12.7749C12.8852 12.6669 12.9369 12.528 12.9369 12.3508C12.9399 12.2771 12.9274 12.2041 12.9004 12.1354Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAave);
export default __webpack_public_path__ + "static/media/aave.d61934301cdf335b499ba9f3b9a9044b.svg";
export { ForwardRef as ReactComponent };